import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./App.css";
import { AppRouter } from "./routes/appRouter";
import { PublicRoutes } from "./routes/publicRoutes";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./authContext";
import i18Next from "i18next";
import { GetNavigationPages } from "./services/getNavigationPages";
var getHashParams = function () {
    var hash = window.location.hash.substring(1); // Remove the leading '#'
    var params = new URLSearchParams(hash);
    var accessToken = params.get("access_token");
    if (accessToken) {
        // You may store token here, e.g., localStorage or state
        console.log("MSI SSO DETECTED");
        localStorage.setItem("msi_access_token", accessToken);
    }
};
function useIdleTimer() {
    var timer;
    var startTimer = function () {
        timer = setTimeout(function () {
            localStorage.removeItem("assurehub");
            window.location.reload();
        }, 60000 * 1000); // 1 minute
    };
    var resetTimer = function () {
        clearTimeout(timer);
        startTimer();
    };
    startTimer();
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    return function () {
        clearTimeout(timer);
        window.removeEventListener("mousemove", resetTimer);
        window.removeEventListener("keydown", resetTimer);
    };
}
function App() {
    var status = useAuth().status;
    getHashParams(); // Call the function to check if there are is SSO token in the URL
    useIdleTimer(); // Add this line
    // Inicializar los permisos para que estén disponibles en el cache
    GetNavigationPages();
    var lng = localStorage.getItem("i18nextLng")
        ? localStorage.getItem("i18nextLng")
        : "es";
    var ns = localStorage.getItem("i18nextDefaultNamespace")
        ? localStorage.getItem("i18nextDefaultNamespace")
        : "default";
    i18Next.loadNamespaces(ns, function () {
        if (ns) {
            i18Next.setDefaultNamespace(ns);
        }
        i18Next.changeLanguage(lng);
    });
    return (_jsx(BrowserRouter, { children: status !== "no-authenticated" ? (_jsx(AppRouter, {})) : (_jsxs(Routes, { children: [_jsx(Route, { path: "/*", element: _jsx(PublicRoutes, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/login", replace: true }) })] })) }));
}
var WrappedApp = function () { return (_jsx(AuthProvider, { children: _jsx(App, {}) })); };
export default WrappedApp;
